import { Component, inject, OnInit } from '@angular/core';
import { ErrorNotificationComponent } from '@components/error-notification/error-notification.component';
import { environment } from '@environments/environment';
import { ConsultationRequestService } from '@services/consultation-request.service';

@Component({
  selector: 'app-consultation-submission-error',
  imports: [ErrorNotificationComponent],
  templateUrl: './consultation-submission-error.component.html',
})
export class ConsultationSubmissionErrorComponent implements OnInit {
  private consultationRequestService = inject(ConsultationRequestService);

  /**
   * Gets the contact email address from the application configuration.
   *
   * @returns {string} the configured support email address
   */
  public get contactEmail(): string {
    return environment.email;
  }

  /**
   * Clears any stored consultation request data after the component is initialized.
   */
  public ngOnInit(): void {
    this.consultationRequestService.clearLastConsultationRequestData();
  }
}
